<div class="broadband-desktop-view">
    <div class="broadband-mobile-view">
        <button *ngFor="let item of labelDetails?.tab" class="fcc-tab-label {{labelDetails?.className}}" [ngClass]="{ 'active': activePlanId === item?.planId }" (click)="tabChange(item?.planId)">{{ item?.name }}</button>
    </div>
    <xm-fcc-card page="line-details">
        <xm-fcc-broadband-label
            class="fcc-label {{labelDetails?.className}}"
            *ngFor="let plan of labelDetails?.plans"
            [ngClass]="{ 'active-label': activePlanId === plan?.planId }"
            [labelDetails]="plan">
        </xm-fcc-broadband-label>
    </xm-fcc-card>
</div>
